import React, { useEffect, useState } from 'react';
import { fetchCategories, createCategory, updateCategory, deleteCategory } from '../api';
import { Button } from '../components/ui/button';
import { Pencil, Trash2 } from 'lucide-react';

function CategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');

  useEffect(() => {
    fetchCategories().then(setCategories);
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!categoryName) return;
    await createCategory({ category_name: categoryName });
    setCategories(await fetchCategories());
    setCategoryName('');
  };

  const startEdit = c => {
    setEditingId(c.category_id);
    setEditName(c.category_name);
  };

  const handleEditSubmit = async e => {
    e.preventDefault();
    await updateCategory(editingId, { category_name: editName });
    setCategories(await fetchCategories());
    setEditingId(null);
  };

  const handleDelete = async id => {
    await deleteCategory(id);
    setCategories(await fetchCategories());
  };

  return (
    <div className="container mx-auto p-4 space-y-6">
      <h1 className="text-3xl font-bold">Categories 1</h1>
      
      <form onSubmit={handleSubmit} className="bg-card p-6 rounded-lg shadow-sm space-y-4">
        <div className="flex gap-4">
          <input
            value={categoryName}
            onChange={e => setCategoryName(e.target.value)}
            placeholder="Category Name"
            required
            className="flex-1 px-3 py-2 rounded-md border border-input bg-background"
          />
          <Button type="submit">Add Category</Button>
        </div>
      </form>

      <div className="space-y-4">
        {categories.length === 0 ? (
          <p className="text-center text-muted-foreground">No categories found</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {categories.map((category) => (
              <div
                key={category.category_id}
                className="bg-card text-card-foreground rounded-lg border p-4 shadow-sm hover:shadow-md transition-shadow"
              >
                {editingId === category.category_id ? (
                  <form onSubmit={handleEditSubmit} className="space-y-4">
                    <input
                      value={editName}
                      onChange={e => setEditName(e.target.value)}
                      required
                      className="w-full px-3 py-2 rounded-md border border-input bg-background"
                    />
                    <div className="flex gap-2">
                      <Button type="submit" size="sm">Save</Button>
                      <Button variant="outline" size="sm" onClick={() => setEditingId(null)}>Cancel</Button>
                    </div>
                  </form>
                ) : (
                  <div className="flex justify-between items-center">
                    <h3 className="font-semibold text-lg">{category.category_name}</h3>
                    <div className="flex gap-2">
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => startEdit(category)}
                      >
                        <Pencil className="h-4 w-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => handleDelete(category.category_id)}
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CategoriesPage; 